import styled from 'styled-components';

import { Text } from '../../../../components';
import { COLORS, SPACE } from '../../../../theme/tokens';
import type { FieldTagKind } from './FieldTag';

export const Root = styled(Text)<{ $kind: FieldTagKind }>`
  display: inline-flex;
  align-items: center;
  padding: ${SPACE[2]} ${SPACE[8]};
  border-radius: 999px;
  border: 1px solid ${COLORS.panelBorder};
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  color: ${(p) => (p.$kind === 'changed-by-platform' ? COLORS.warning : COLORS.textMuted)};
`;
